import React from 'react';
import { Forms, Modal, SaveButton, SystemText } from '@salesperformanceint/e4shared';
import { useDispatch } from 'react-redux';
import { toggleFormHelp } from 'actions/ui';

export const Notify = ({ show, close, send }) => {
    const dispatch = useDispatch();

    const [value, setValue] = React.useState('');
    const [saving, setSaving] = React.useState(false);
    const [error, setError] = React.useState('');

    const text = {
        title: SystemText('Dashboard/Manage/Notify/Title'),
        fields: {
            message: {
                label: SystemText('Dashboard/Manage/Notify/Fields/Message/Label'),
                error: SystemText('Dashboard/Manage/Notify/Fields/Message/Error'),
                help: SystemText('Dashboard/Manage/Notify/Fields/Message/Help'),
            },
        },
        buttons: {
            save: SystemText('Dashboard/Manage/Notify/Buttons/Save'),
            cancel: SystemText('Dashboard/Manage/Notify/Buttons/Cancel'),
        },
    };

    const closeMe = () => {
        setError('');
        close();
    };

    const checkAndSend = () => {
        if (value) {
            send(value);
            closeMe();
        } else {
            setSaving(false);
            setError(text.fields.message.error);
        }
    };

    const footer = (
        <div>
            <button onClick={closeMe} className="btn btn-default" data-testid="button-cancel">
                {text.buttons.cancel}
            </button>
            <SaveButton
                saving={saving}
                setSaving={setSaving}
                onClick={checkAndSend}
                className="btn btn-primary"
                data-testid="button-save"
            >
                {text.buttons.save}
            </SaveButton>
        </div>
    );

    return (
        <Modal
            show={show}
            onClose={closeMe}
            title={text.title}
            footer={footer}
            toggleFormHelp={() => dispatch(toggleFormHelp())}
        >
            <div>
                <Forms.Textarea
                    rows="10"
                    data-testid="text-message"
                    value={value}
                    onChange={setValue}
                    label={text.fields.message.label}
                    help={text.fields.message.help}
                    error={error}
                />
            </div>
        </Modal>
    );
};

export default Notify;
